<template>
  <div>
    <router-view />
  </div>
</template>
<script>
export default {
  name: "ipClassCardManage"
};
</script>
<style lang="less" scoped></style>
